import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { SectionHeader } from "@/components/common/Widgets";
import { fmtDate } from "@/lib/format";
import { Plus, Search, Users, Upload } from "lucide-react";

export default function CustomersPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await api.get("/customers", { params: { q: q || undefined } });
      setItems(res.data);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => { fetchData(); /* eslint-disable-next-line */ }, []);

  return (
    <div className="space-y-5">
      <SectionHeader title="Customers" subtitle="All borrower profiles" action={
        <div className="flex items-center gap-2">
          <Link to="/customers/bulk-upload"><Button variant="outline" data-testid="customers-bulk-button"><Upload className="h-4 w-4 mr-1.5" />Bulk Upload</Button></Link>
          <Link to="/customers/new"><Button data-testid="customers-new-button"><Plus className="h-4 w-4 mr-1.5" />New Customer</Button></Link>
        </div>
      } />
      <Card className="p-3">
        <form onSubmit={(e) => { e.preventDefault(); fetchData(); }} className="flex items-center gap-2">
          <div className="relative flex-1">
            <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
            <Input placeholder="Search by name, CIF, PAN or mobile…" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" data-testid="customers-search-input" />
          </div>
          <Button type="submit" variant="secondary" data-testid="customers-search-button">Search</Button>
        </form>
      </Card>
      <Card className="p-0 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-muted/40 text-xs uppercase tracking-wide text-muted-foreground">
              <tr>
                <th className="text-left px-3 py-2.5">CIF</th>
                <th className="text-left px-3 py-2.5">Name</th>
                <th className="text-left px-3 py-2.5">Constitution</th>
                <th className="text-left px-3 py-2.5">Branch</th>
                <th className="text-left px-3 py-2.5">PAN</th>
                <th className="text-left px-3 py-2.5">GSTIN</th>
                <th className="text-right px-3 py-2.5">CIBIL</th>
                <th className="text-left px-3 py-2.5">Created</th>
              </tr>
            </thead>
            <tbody>
              {loading && <tr><td colSpan={8} className="text-center py-8 text-muted-foreground">Loading…</td></tr>}
              {!loading && items.length === 0 && (
                <tr><td colSpan={8} className="text-center py-12">
                  <Users className="h-8 w-8 text-muted-foreground mx-auto mb-2" />
                  <div className="text-sm">No customers yet.</div>
                  <Link to="/customers/new"><Button className="mt-3" size="sm">Onboard the first customer</Button></Link>
                </td></tr>
              )}
              {items.map((c) => (
                <tr key={c.id} className="border-t border-border hover:bg-muted/30 cursor-pointer" onClick={() => navigate(`/customers/new?cust=${c.id}`)}>
                  <td className="px-3 py-2 mono text-xs">{c.cif}</td>
                  <td className="px-3 py-2 font-medium">{c.name}</td>
                  <td className="px-3 py-2 text-xs">{c.constitution}</td>
                  <td className="px-3 py-2 text-xs">{c.branch || "—"}</td>
                  <td className="px-3 py-2 mono text-xs">{c.pan || "—"}</td>
                  <td className="px-3 py-2 mono text-xs">{c.gstin || "—"}</td>
                  <td className="px-3 py-2 num-right">{c.cibil_score || "—"}</td>
                  <td className="px-3 py-2 text-xs text-muted-foreground mono">{fmtDate(c.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
